export let endSession = (dispatch, currentCompanyId, actions, getState, data) => {
    let isMyService, isStarted = false
    if (getState().app.customers.current.length > 0) {
        let isExist = getState().app.customers.current.find(i => i.userId === data.userId && i._id === data.requestId)
        if (isExist) {
            isMyService = isExist
            isStarted = true
        }
    }
    if (getState().app.serviceRequests.customers.length > 0) {
        let isExist = getState().app.serviceRequests.customers.find(i => i.userId === data.userId && i._id === data.requestId)
        if (isExist) {
            isMyService = isExist
        }
    }
    if (currentCompanyId === data.companyId && isMyService) {
        if (isStarted) {

            dispatch(actions.clearChatHistory(data.customerId))
            dispatch(actions.clearChat(data.userId))
            dispatch(actions.endSession(data.userId))
        }
        else {
            dispatch(actions.cancelServiceRequest(data.requestId))

        }
    }
}
